import { AppId, Route } from '@lumapps/router';
import { socialProfile } from '@lumapps/user-profile/routes';
import { USER_PROFILE_VIEW } from '@lumapps/user-profile/types';
import { hexUUIDToBigInt } from '@lumapps/utils/string/hexUUIDToBigInt';

export const BEEKEEPER_INTEGRATION = 'beekeeper-integration';
export const BEEKEEPER_LUMAPPS_SINGLE_DOMAIN = 'lumapps_single_domain_development';
export const LUMAPPS_INTEGRATION_MAIN = 'is-lumapps-integration-main';

export enum IFRAMES {
    FORMS = 'forms',
    SURVEYS = 'surveys',
    WORKFLOWS = 'workflows',
    ANALYTICS_TASKS = 'analytics-tasks',
    ANALYTICS_FORMS = 'analytics-forms',
    ANALYTICS_WORKFLOWS = 'analytics-workflows',
}

export const BKPR_ID = 'bk';
export const BKPR_PREFIX = `/${BKPR_ID}`;

/** Path prefixes to consider as external on redirects */
export const EXTERNAL_PATH_PREFIXES = ['/v2/organizations/'];

export const SUPPORTED_URLS_BY_APPS: Record<string, AppId[]> = {
    '/analytics/tasks': [AppId.backOffice],
    '/analytics/forms': [AppId.backOffice],
    '/analytics/workflows': [AppId.backOffice],
    '/tasks': [AppId.frontOffice],
    '/forms': [AppId.backOffice, AppId.frontOffice],
    '/surveys': [AppId.backOffice, AppId.frontOffice],
    '/workflows': [AppId.backOffice],
    '/chats': [AppId.frontOffice],
    '/profiles': [AppId.frontOffice],
};

export const APPS_PREFIX_MAPPINGS: Partial<Record<AppId, (url: string) => string>> = {
    [AppId.frontOffice]: (url: string) => url,
    [AppId.backOffice]: (url: string) => {
        const cleanUrl = url.startsWith('/') ? url.slice(1) : url;
        return `/dashboard#${cleanUrl}`;
    },
};

export const MAPPED_ROUTES: Record<string, (url: string) => Route> = {
    '/profiles': (url: string) => {
        const userId = url.split('/profiles/')[1];
        const decimalId = hexUUIDToBigInt(userId);
        return socialProfile({ userId: decimalId, view: USER_PROFILE_VIEW.about, isUserSpaceEnabled: true });
    },
};

export const PREFIXES_FOR_SUPPORTED_ROUTES_LIST = Object.keys(SUPPORTED_URLS_BY_APPS);
export const PREFIXES_FOR_MAPPED_ROUTES_LIST = Object.keys(MAPPED_ROUTES);
